import React, { useEffect } from 'react';
import { Typography, Row, Col } from 'antd';
import TeamSummaryTable from './SummaryTable';
import { useAppContext } from './AppContext';

const { Title, Text } = Typography;


const TeamSummary = () => {
    const { tableData } = useAppContext();
    const [directCount, setdirectCount] = React.useState(0);
    const [indirectCount, setindirectCount] = React.useState(0);
    const { upName } = useAppContext();

    useEffect(() => {
        //console.log('upName:', upName);
        const directs = tableData.filter((row) => { return row.managerEmail && row.managerEmail.toString().toLowerCase() === upName.toString().toLowerCase(); });
        setdirectCount(directs.length);

        setindirectCount(tableData.length - directs.length);
    }, [upName, tableData]);

    return (
        <div >
            <div>
                <br />
                <Row>
                    <Col>
                        <Title style={{ fontSize: '18px' }}>Team Size</Title>
                    </Col>

                </Row>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <Text>Direct</Text>
                        <br />
                        <Text style={{ fontWeight: 'bold' }}>{directCount}</Text>

                    </Col>
                    <Col span={12}>
                        <Text>Indirect</Text>
                        <br />
                        <Text style={{ fontWeight: 'bold' }}>{indirectCount}</Text>
                    </Col>
                </Row>
            </div>
            <br />

            <div>

                <TeamSummaryTable />
            </div>



        </div>
    );
};

export default TeamSummary;
